let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("fliVL"), load("6DaVr")]).then(() => parcelRequire('3aj3b'));